export const CHIP_TYPE = {
    BASIC: 'basic',
    WARNING: 'warning',
    ERROR: 'error',
    PRIMARY: 'primary',
};
